import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchContainer.css';
import SearchBarContainerWithRouter from '../home/searchBar/SearchBarContainerWithRouter';
import { fetchAuthenticatedJSON, urlParams, apiErrorMessage } from 'utils/request';
import { MIN_CHARACTERS } from 'utils/search';
import { starfishMediaType, SFNotification } from 'utils/types';
import SearchView from './SearchView';
import { withNotification } from '../../common/withNotification';

class SearchContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { value: props.query, typeahead: props.results, isLoading: false };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ( this.props.query !== nextProps.query ) {
      // If the new query has less than min chars, simply reset results
      if ( nextProps.query.length < MIN_CHARACTERS ) this.props.onResultsFetched({services: [], connections: []});

      // If new query param is the same of the typeahead param, save a roundtrip
      else if ( nextProps.query === this.state.value ) this.props.onResultsFetched(this.state.typeahead);

      // Fetch new results if our query is different from typeahead (user input direct in URL)
      else this.fetchResults(nextProps.query);

      // If our query param changes, update value of search
      this.setState({value: nextProps.query});
    }
  }

  // This check is to avoid a weird behavior where user would focus on the search input but then
  // type a different search in the addressbar. When the page reloaded, the focus would still
  // be in the search input and consequently the suggestion box would trigger
  componentDidUpdate(prevProps) {
    if ( this.props.query !== prevProps.query ) {
      const element = document.activeElement;
      if ( element.tagName && element.tagName.toLowerCase() === "input" ) element.blur();
    }
  }

  // If component mounted first time without any results but with a query value set, fetch new results
  componentDidMount() {
    if ( this.hasNoResults() ) this.fetchResults(this.props.query);
  }

  // This is necessary to avoid keeping the same search text when user leaves page
  componentWillUnmount() {
    this.props.resetQuery();
  }

  fetchResults(query) {
    // Do not query DB if query value is less than MIN_CHARACTERS
    if ( query.length < MIN_CHARACTERS ) return;

    this.setState({isLoading: true});
    const URL = `../api/starfish/success-network/connections?${urlParams({search: query})}`;
    return fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(value => {
      this.props.onResultsFetched(value);
      this.setState({typeahead: value});
    })
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({isLoading: false}));
  }

  hasNoResults() {
    const { services, connections } = this.props.results;
    return services.length === 0 && connections.length === 0;
  }

  render() {
    return (
      <div className={css['container']}>
        {this.props.notification.render()}
        <SearchBarContainerWithRouter
          results={this.state.typeahead}
          onResultsFetched={typeahead => this.setState({typeahead})}
          value={this.state.value}
          isStudent={this.props.isStudent}
          onSearchChange={value => this.setState({value})}
          onFailure={this.props.notification.error}
        />
        <SearchView
          connections={this.props.results.connections}
          services={this.props.results.services}
          query={this.state.value}
          isLoading={this.state.isLoading}
          isStudent={this.props.isStudent}
          isServiceMember={this.props.isServiceMember}
        />
      </div>
    );
  }
}

SearchContainer.propTypes = {
  results: PropTypes.object.isRequired,
  onResultsFetched: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  resetQuery: PropTypes.func.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  notification: SFNotification.isRequired
};

export default withNotification(SearchContainer);
